// extracted by mini-css-extract-plugin
export default {"paragraph":"P_paragraph__soVb4","ellipsis":"P_ellipsis__RbGak","hover":"P_hover__my+7Q"};